// extracted by mini-css-extract-plugin
export default {"pill":"StatusPill_pill__TVtLc","green":"StatusPill_green__fsD2p","red":"StatusPill_red__SFOIu","gray":"StatusPill_gray__tXizv","yellow":"StatusPill_yellow__1317g"};